import React, { useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";

export default function CoursePlayerPage() {
  const { courseId } = useParams();

  const course = useMemo(() => {
    return {
      id: courseId || "course_mock_001",
      title: "AI Automation 101",
      lessons: [
        { id: "l1", title: "แนะนำคอร์ส + เป้าหมาย", duration: "10:12" },
        { id: "l2", title: "พื้นฐาน Automation", duration: "18:40" },
        { id: "l3", title: "Prompt สำหรับงานจริง", duration: "22:05" },
        { id: "l4", title: "Workshop: ทำ Workflow แรก", duration: "31:10" },
        { id: "l5", title: "สรุป + แนวทางต่อยอด", duration: "12:30" },
      ],
    };
  }, [courseId]);

  const [activeLessonId, setActiveLessonId] = useState(course.lessons[0]?.id);

  const activeLesson = course.lessons.find((l) => l.id === activeLessonId) || course.lessons[0];

  const completedCount = useMemo(() => {
    // mock: สมมุติเรียนไปแล้ว 1 บท
    return 1;
  }, []);

  const progressPct = Math.round((completedCount / course.lessons.length) * 100);

  return (
    <div className="container-fluid py-3">
      <div className="px-2 px-lg-3">
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between mb-3">
          <div>
            <div className="d-flex gap-2 align-items-center">
              <Link to="/courses" className="text-decoration-none">
                ← คอร์สทั้งหมด
              </Link>
              <span className="text-secondary">/</span>
              <span className="fw-semibold">{course.title}</span>
            </div>
            <div className="text-secondary small mt-1">
              บทเรียนที่กำลังดู: <span className="fw-semibold">{activeLesson?.title}</span>
            </div>
          </div>

          <div className="text-end">
            <div className="small text-secondary">Progress (mock)</div>
            <div className="fw-semibold">{progressPct}%</div>
          </div>
        </div>

        <div className="row g-3">
          {/* left: lessons */}
          <div className="col-lg-4 col-xl-3">
            <div className="card">
              <div className="card-header fw-semibold">บทเรียน</div>
              <div className="list-group list-group-flush">
                {course.lessons.map((l, idx) => {
                  const active = l.id === activeLessonId;
                  return (
                    <button
                      key={l.id}
                      type="button"
                      className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${
                        active ? "active" : ""
                      }`}
                      onClick={() => setActiveLessonId(l.id)}
                      style={{ textAlign: "left" }}
                    >
                      <div>
                        <div className="fw-semibold">
                          {idx + 1}. {l.title}
                        </div>
                        <div className={`${active ? "" : "text-secondary"} small`}>
                          {l.duration}
                        </div>
                      </div>
                      <span className={`badge ${active ? "text-bg-light" : "text-bg-secondary"}`}>
                        ▶
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="alert alert-info mt-3 mb-0">
              หน้านี้เป็น mockup: ยังไม่ตรวจสิทธิ์การเรียน/ยังไม่บันทึก progress
            </div>
          </div>

          {/* right: player */}
          <div className="col-lg-8 col-xl-9">
            <div className="card overflow-hidden">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div className="fw-semibold">{activeLesson?.title}</div>
                <div className="text-secondary small">{activeLesson?.duration}</div>
              </div>

              {/* mock video area */}
              <div className="ratio ratio-16x9 bg-dark d-flex align-items-center justify-content-center">
                <div className="text-white text-center px-3">
                  <div className="h5 mb-2">Video Player (Mock)</div>
                  <div className="opacity-75">
                    ตรงนี้ในอนาคตคุณจะฝัง Vimeo / Video player จริง
                  </div>
                </div>
              </div>

              <div className="card-body">
                <h2 className="h6">โน้ต/เอกสารประกอบ (mock)</h2>
                <p className="text-secondary mb-3">
                  พื้นที่สำหรับคำอธิบายบทเรียน, ไฟล์แนบ, ลิงก์ดาวน์โหลด หรือสรุปประเด็นสำคัญ
                </p>

                <div className="d-flex flex-wrap gap-2">
                  <button className="btn btn-outline-secondary btn-sm" type="button" disabled>
                    ดาวน์โหลดไฟล์แนบ (mock)
                  </button>
                  <button className="btn btn-outline-secondary btn-sm" type="button" disabled>
                    ทำแบบทดสอบ (mock)
                  </button>
                  <button className="btn btn-outline-secondary btn-sm" type="button" disabled>
                    ขอ Certificate (mock)
                  </button>
                </div>
              </div>
            </div>

            {/* navigation */}
            <div className="d-flex justify-content-between mt-3">
              <button className="btn btn-outline-secondary" type="button" disabled>
                ← บทก่อนหน้า
              </button>
              <button className="btn btn-primary" type="button" disabled>
                บทถัดไป →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
